import { render, staticRenderFns } from "./adesao-direta.vue?vue&type=template&id=6493c2a0"
import script from "./adesao-direta.vue?vue&type=script&lang=js"
export * from "./adesao-direta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports